<template>
  <v-card>
    <v-card-title>Comissão</v-card-title>
    <v-card-text>
      <Chart :chartOptions="chartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
import Chart from "@/components/BaseChart";
import { mapGetters } from "vuex";
export default {
  components: {
    Chart
  },
  data() {
    return {
      indicador: ["novos", "p1", "p2", "usados"],
      chartOptions: {
        title: {
          text: ""
        },
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: "350"
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true
            },
            startAngle: 0,
            endAngle: 360,
            size: "100%",
            colors: ["#CC152C", "#212121", "#C9C9C9", "#757575"]
          }
        },
        series: [
          {
            type: "pie",
            innerSize: "60%",
            data: []
          }
        ],

        credits: {
          enabled: false
        },

        lang: {
          noData: "Não há dados para serem apresentados"
        },
        noData: {
          style: {
            fontWeight: "normal",
            fontSize: "1rem",
            color: "rgba(0, 0, 0, 0.6)"
          }
        }
      }
    };
  },

  computed: {
    ...mapGetters("relatorios", ["getRelatorios"])
  },

  watch: {
    getRelatorios(value) {
      this.chartOptions.series[0].data = [];
      this.setComissao(value);
    }
  },

  methods: {
    setComissao(data) {
      this.indicador.forEach(element => {
        this.chartOptions.series[0].data.push([
          element,
          data[element].comissao
        ]);
      });
    }
  }
};
</script>

<style></style>